(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["personalization-field"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('personalization-field')) {
    customElements.define('personalization-field', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const input = this.querySelector('textarea');
        const validate = () => {
          input.setCustomValidity(input.required && !input.value.trim() ? input.dataset.requiredMessage : '');
        };
        input.addEventListener('input', validate);
        this.addEventListener('personalization:change', (event) => {
          const label = String(event.detail || '').trim();
          this.hidden = !label;
          input.required = Boolean(label);
          input.disabled = !label;
          this.querySelector('[data-personalize-label]').textContent = label ? label + ' *' : '';
          validate();
        });
        validate();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
